import { render } from "./OrderList.vue?vue&type=template&id=c0987d48&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=c0987d48&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-c0987d48"

export default script